import React, { createContext, useContext, useEffect, useState } from 'react';
import client from '../api/client';

const OrgContext = createContext(null);

function detectSubdomain() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null;
  const parts = hostname.split('.');
  // thxuk.localhost  or  thxuk.domain.com
  if (parts.length >= 2) return parts[0];
  return null;
}

const DEFAULT_BRANDING = {
  id: null,
  name: 'AP Automation',
  display_name: 'AP Automation',
  primary_color: '#B71530',
  logo_url: null,
  favicon_url: null,
  subdomain: null,
};

export function OrgProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const subdomain = detectSubdomain();
    const params = subdomain ? `?subdomain=${subdomain}` : '';
    client.get(`/orgs/branding${params}`)
      .then(r => setBranding({ ...DEFAULT_BRANDING, ...r.data }))
      .catch(() => setBranding(DEFAULT_BRANDING))
      .finally(() => setLoading(false));
  }, []);

  // Apply favicon dynamically
  useEffect(() => {
    if (branding.favicon_url) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.rel = 'shortcut icon';
      link.href = branding.favicon_url;
      document.head.appendChild(link);
    }
  }, [branding.favicon_url]);

  return (
    <OrgContext.Provider value={{ branding, loading }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrg must be used within OrgProvider');
  return ctx;
}
